import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, V1 } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("sano_token");
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.get(`${V1}/auth/me`);
      setUser(data);
    } catch {
      localStorage.removeItem("sano_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (token, userData) => {
    localStorage.setItem("sano_token", token);
    setUser(userData);
  };
  const logout = () => {
    localStorage.removeItem("sano_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
